import React, { useEffect, useRef } from "react";
import { bool, object } from "prop-types";
import { Link } from "@quintype/components";

import { AuthorWithTime, HeroImage } from "../../../arrow";
import { Headline } from "../../atoms";
import LiveButton from "../../atoms/live-button";
import { useDeviceType } from "../../customHooks/useDeviceType";

import "./StoryCard.m.css";

const StoryCard = ({ story, showAuthorContent, tagPage = false, firstTagPage = false, isAdfreePage = false }) => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const storyCardWrapper = isAdfreePage ? "story-card-wrapper-no-ad" : "story-card-wrapper";
  return (
    <div className={storyCardWrapper} styleName={`story-card-wrapper ${tagPage ? "tag-page-card-wrapper" : ""}`}>
      {tagPage ? (
        <HeroImage
          story={story}
          aspectRatio={[[16, 9]]}
          showIcon={true}
          tagPage={tagPage}
          firstTagPage={firstTagPage}
        />
      ) : (
        <Link href={`/${story?.slug}`} disableAjaxLinks={true}>
          <HeroImage story={story} aspectRatio={[[16, 9]]} showIcon={true} />
        </Link>
      )}
      <div>
        <Link href={`/${story?.slug}`} disableAjaxLinks={true}>
          <Headline type={2}>{story?.headline}</Headline>
        </Link>
        <AuthorWithTime
          story={story}
          separator="divider"
          showReadTime={false}
          showMultipleAuthor={true}
          showAuthorContent={showAuthorContent}
        />
      </div>
    </div>
  );
};

StoryCard.defaultProps = {
  showAd: false,
  story: {},
};

StoryCard.propTypes = {
  showAd: bool,
  story: object,
  tagPage: bool,
  firstTagPage: bool,
  showAuthorContent: bool,
};

export default StoryCard;
